/* eslint-disable react/no-find-dom-node */
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import { Table, message } from 'antd';

//import { modelManager } from '../../modelManager/modelManager.tsx'
import PropTypes from 'prop-types';

import { Button, Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';







class Grid extends Component {
  constructor(props) {
    super(props);



    this.state = {
      keyField: '',
      queryColumns: [],
      height: 0,
      quickFilterString: '',
      rowActions: props.rowActions || [],
      filters: {},
      pageSize: 10

    };
    this.refContainer = React.createRef()
    this.lastScrollTop = 0;
    this.onScroll = this.onScroll.bind(this)
    this.onWheel = this.onWheel.bind(this)
    this.onPaginationChange = this.onPaginationChange.bind(this)
    this.getRowRange = this.getRowRange.bind(this)
  }



  componentDidMount() {

    this.refRoot = ReactDOM.findDOMNode(this);
    //this.refHeader = this.refRoot.getElementsByClassName('grid-fonction-header')[0];
    //this.refFooter = this.refRoot.getElementsByClassName('grid-fonction-footer')[0];

    this.refTableBody = this.refRoot.getElementsByClassName('ant-table-body')[0];
    this.refTableBody.onscroll = this.onScroll;
    this.refTableBody.onwheel = this.onWheel;

    //this.refFixedRigth = this.refRoot.getElementsByClassName('ant-table-fixed-right')[0];
    //if (this.refFixedRigth)
    //  this.refFixedRigth.onwheel = this.onWheel;
    this.refTableBody.onwheel = this.onWheel;
    this.handleResize();
  }

  tableMaxHeight = () => {
    let height

    if (this.refContainer && this.refContainer.current !== null) {
      height = this.refContainer.current.clientHeight
    } else {
      height = 50
    }

    return height - 60
  }

  handleResize = () => {
    //Gestion du Scroll

    if (this.tableMaxHeight() !== this.state.height)
      this.setState({ height: this.tableMaxHeight() })

  }



  componentDidUpdate(prevProps) {
    if (prevProps.page !== this.props.page) {
      //let refTable = this.refTableBody.getElementsByClassName('ant-table-fixed')[0];
      let refTable = this.refTableBody.firstChild.getElementsByClassName('ant-table-tbody')[0];

      if (prevProps.page < this.props.page) {
        let firsRow = refTable.getElementsByTagName('tr')[0];
        if (firsRow)
          firsRow.scrollIntoView(false);
        else {
          this.minRow = undefined;
          this.maxRow = undefined
        }
      } else {
        let firsRow = refTable.getElementsByTagName('tr')[this.props.pageSize - 1];
        if (firsRow)
          firsRow.scrollIntoView(false)
        else {
          this.minRow = undefined;
          this.maxRow = undefined
        }
      }

      this.lastScrollTop = 0
      this.getRowRange()
    }

    this.handleResize();
  }

  componentWillUnmount() {
    if (this.refTableBody)
      this.refTableBody.onscroll = undefined;
    if (this.refTableBody)
      this.refTableBody.onwheel = undefined;
    if (this.refFixedRigth)
      this.refFixedRigth.onwheel = undefined;

    if (this.refFixedRigth)
      this.refFixedRigth.onwheel = undefined;
  }

  onWheel(e) {
    const { filters } = this.state

    if (this.props.loading) {
      e.preventDefault()
      return
    }

    if ((this.minRow === undefined) || (this.maxRow === undefined)) return;
    if (e.deltaY > 0) {
      //gestion descente
      if ((this.maxRow === (this.props.page * this.props.pageSize) - 1) && (this.props.page < Math.trunc(this.props.total / this.props.pageSize) + 1))
        this.props.handleFetch(this.props.page + 1, filters)
    } else {
      //gestion monté;
      if ((this.minRow === ((this.props.page - 1) * this.props.pageSize)) && (this.props.page > 1))
        this.props.handleFetch(this.props.page - 1, filters)

    }
  }

  onScroll(e) {
    let element = e.target

    const { scrollTop } = element;
    /*
        let direction;
        if (scrollTop > this.lastScrollTop) {
          direction = 'Down';
        } else {
          direction = 'Up'
        }
    */
    this.lastScrollTop = scrollTop;

    this.getRowRange()

  }

  getRowRange() {
    const refTable = this.refTableBody.getElementsByClassName('ant-table-tbody')[0];
    var children = refTable.children

    if (children.length === 0) return

    let VisibleRowHeight = 0;
    const decalage = (this.props.page - 1) * this.props.pageSize
    for (var i = 0; i < children.length - 1; i++) {
      let row = children[i + 1];
      let rowHeight = row.clientHeight

      if (row.offsetTop + rowHeight < this.lastScrollTop) continue;

      this.minRow = i + decalage;

      VisibleRowHeight = rowHeight - (this.lastScrollTop - row.offsetTop);
      i++;
      while (i < children.length - 1) {
        row = children[i + 1];
        VisibleRowHeight = VisibleRowHeight + row.clientHeight;
        this.maxRow = i + decalage;
        if (VisibleRowHeight > this.refTableBody.clientHeight) break
        i++;
      }
      break;

    }

  }

  onPaginationChange(page) {
    const { filters, sorter } = this.state

    this.props.handleFetch(page, filters, sorter)
  }

  handleSearch = (selectedKeys, dataIndex, confirm) => {
    confirm()
  }
  /*
    onFilter = (value, record, dataIndex) => {
  
    }
  */
  handleReset = (dataIndex, clearFilters) => {

    clearFilters();
  }



  handleTableChange = (pagination, filters, sorter) => {



    this.props.handleFetch(pagination, filters, sorter);
  };







  onError = (error) => {
    message.error(error)
  }




  onEditClick = (event, record) => {
    message.info(record.rownum)
  }

  onRowDoubleClick = (record, rowIndex, event) => {
    if (this.props.rowDoubleClick !== undefined)
      this.props.rowDoubleClick(record, rowIndex, event)
  }


  render() {


    const { actions, data, columns, pagination, loading, keyField } = this.props

    return (

      <Container>
        <div className='gridHeader'>
          {this.props.title}
        </div>
        {this.props.actions !== undefined && this.props.actions.length > 0 ?
          <Row>
            <Col sm={6} >
              {
                this.props.filterComponent!== undefined ?
                this.props.filterComponent():
                null
              }
            </Col>
            <Col sm={6} >
              <div className="gridActionBar">
                {

                  actions.map((action) => {

                    const renderTooltip = (props) =>
                      <Tooltip id={props.id}>
                        {props.tooltip}
                      </Tooltip>

                    return (
                      <OverlayTrigger
                        key={action.id}
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip(action)}
                      >

                        <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event) }}> {action.icon}</Button>

                      </OverlayTrigger>

                    )

                  })

                }
              </div>
            </Col>
          </Row>
          : null
        }
        <Table
          rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
          footer={this.props.footer}
          scroll={{ x: '100%', y: '100%' }}
          pagination={{
            ...pagination,

          }}
          columns={columns}
          dataSource={data}
          rowKey={keyField}
          loading={loading}
          size={'small'}
          onChange={this.handleTableChange}
          rowSelection={this.props.rowSelection ? this.props.rowSelection : null}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => { }, // click row
              onDoubleClick: event => { this.onRowDoubleClick(record, rowIndex, event) }, // double click row
              onContextMenu: () => { }, // right button click row
              onMouseEnter: () => { }, // mouse enter row
              onMouseLeave: () => { }, // mouse leave row
            };
          }}
          summary={this.props.summary}
        />
      </Container>


    )
  }
}
Grid.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  loading: PropTypes.bool,
  total: PropTypes.number,
  handleFetch: PropTypes.func,
  rowDoubleClick: PropTypes.func,
  data: PropTypes.array,
  colums: PropTypes.array,
  keyField: PropTypes.string,
  onQuickFilterUpdate: PropTypes.func,
  rowSelection: PropTypes.any,
  rowActions: PropTypes.array,
  columns: PropTypes.array,
  actions: PropTypes.array,
  modes: PropTypes.array,
  maxHeight: PropTypes.number,
  summary: PropTypes.func,
  footer: PropTypes.func,
  filterComponent:PropTypes.func
};
export default Grid;
